/**
 * Private jets fleet gallery — image URLs from Axonall S3 (per-aircraft subfolders).
 * Card uses primary exterior when listed; interiorSrc feeds the detail modal carousel (full set, order preserved).
 */

const S3 = 'https://s3.eu-north-1.amazonaws.com/spaceaxonall.com/Axonall-studio/jets/jets';

const u = (folderAndFile) => `${S3}/${folderAndFile}`;

export const PRIVATE_JETS_GALLERY = [
    {
        name: 'Beechjet 400A',
        category: 'Light Jet',
        capacity: '7–8 passengers',
        range: '1,500 nm',
        speed: '450 kts',
        size: 'normal',
        src: u('Beechjet+400A/1723210767Beechjet-400A_(1).jpg'),
        interiorSrc: [
            u('Beechjet+400A/1723210728Beechjet-400A-night.jpg'),
            u('Beechjet+400A/1723210767Beechjet-400A_(1).jpg'),
            u('Beechjet+400A/1723210778Beechjet-400A-seating.jpg'),
            u('Beechjet+400A/1723210788Beechjet-400A-interior.jpg'),
        ],
    },
    {
        name: 'Cessna Citation CJ3',
        category: 'Light Jet',
        capacity: '8–9 passengers',
        range: '2,040 nm',
        speed: '416 kts',
        size: 'normal',
        src: u('Cessna+CJ3/1723210862Cessna-CJ3.jpg'),
        interiorSrc: [
            u('Cessna+CJ3/1723210862Cessna-CJ3.jpg'),
            u('Cessna+CJ3/1723210897Cessna-CJ3-flight_(1).jpg'),
            u('Cessna+CJ3/1723210908Cessna-CJ3-interior.jpg'),
        ],
    },
    {
        name: 'Bombardier Challenger 350',
        category: 'Midsize Jet',
        capacity: '9–10 passengers',
        range: '3,200 nm',
        speed: '459 kts',
        size: 'large',
        src: u('Challenger+350/1723211620Challenger-350.jpg'),
        interiorSrc: [
            u('Challenger+350/1723211620Challenger-350.jpg'),
            u('Challenger+350/1723211629Challenger-350-flight.jpg'),
            u('Challenger+350/1723211642Challenger-350-seating.jpg'),
            u('Challenger+350/1723211656Challenger-350-rear-view.jpg'),
        ],
    },
    {
        name: 'Challenger 601 / 604 / 605',
        category: 'Heavy Jet',
        capacity: '12–14 passengers',
        range: '3,600–4,000 nm',
        speed: '470 kts',
        size: 'large',
        src: u('Challenger+601++Challenger+604++Challenger+605/1723213250challenger-605-exterior_(1).jpg'),
        interiorSrc: [
            u('Challenger+601++Challenger+604++Challenger+605/1723213063Challenger-601-night.jpg'),
            u('Challenger+601++Challenger+604++Challenger+605/1723213103Challenger-601-inteior.jpg'),
            u('Challenger+601++Challenger+604++Challenger+605/1723213143Challenger-604-full.jpg'),
            u('Challenger+601++Challenger+604++Challenger+605/1723213211Challenger-604-interior.jpg'),
            u('Challenger+601++Challenger+604++Challenger+605/1723213250challenger-605-exterior_(1).jpg'),
            u('Challenger+601++Challenger+604++Challenger+605/1723213270605-interior.jpg'),
        ],
    },
    {
        name: 'Citation Encore',
        category: 'Light Jet',
        capacity: '7–8 passengers',
        range: '1,720 nm',
        speed: '430 kts',
        size: 'normal',
        src: u('Citation+Encore/1723210532Citation-Encore-takeoff.jpg'),
        interiorSrc: [
            u('Citation+Encore/1723210532Citation-Encore-takeoff.jpg'),
            u('Citation+Encore/1723210541Citation-Encore-landed.jpg'),
            u('Citation+Encore/1723210561Citation-Encore-interior.jpg'),
            u('Citation+Encore/1723210573Citation-Encore-amenities.jpg'),
        ],
    },
    {
        name: 'Citation Sovereign',
        category: 'Midsize Jet',
        capacity: '8–9 passengers',
        range: '2,847 nm',
        speed: '458 kts',
        size: 'large',
        src: u('Citation+Sovereign/1723211857Citation-Sovereign-night.jpg'),
        interiorSrc: [
            u('Citation+Sovereign/1723211857Citation-Sovereign-night.jpg'),
            u('Citation+Sovereign/1723211869Citation-Sovereign-midflight.jpg'),
            u('Citation+Sovereign/1723211905Citation-Sovereign-interior.jpg'),
        ],
    },
    {
        name: 'Citation V',
        category: 'Light Jet',
        capacity: '7–8 passengers',
        range: '1,900 nm',
        speed: '430 kts',
        size: 'normal',
        src: u('Citation+V/1723210306Citation-V_(1).jpg'),
        interiorSrc: [
            u('Citation+V/1723210295Citation-V-midflight.jpg'),
            u('Citation+V/1723210306Citation-V_(1).jpg'),
            u('Citation+V/1723210316Citation-V-interior-2.jpg'),
            u('Citation+V/1723210330Citation-V-interior.jpg'),
        ],
    },
    {
        name: 'Citation X',
        category: 'Heavy Jet',
        capacity: '8–12 passengers',
        range: '3,460 nm',
        speed: '527 kts',
        size: 'large',
        src: u('Citation+X/1723211539Citation-X-preflight.jpg'),
        interiorSrc: [
            u('Citation+X/1723211539Citation-X-preflight.jpg'),
            u('Citation+X/1723211548Citation-X-flight_(1).jpg'),
            u('Citation+X/1723211558Citation-X-interior.jpg'),
        ],
    },
    {
        name: 'Citation XLS',
        category: 'Midsize Jet',
        capacity: '8–9 passengers',
        range: '1,961 nm',
        speed: '431 kts',
        size: 'normal',
        src: u('Citation+XLSCitation+XLS/1723211065Citation-XLS-flight-1_(1).jpg'),
        interiorSrc: [
            u('Citation+XLSCitation+XLS/1723211065Citation-XLS-flight-1_(1).jpg'),
            u('Citation+XLSCitation+XLS/1723211076Citation-XLS-bank.jpg'),
            u('Citation+XLSCitation+XLS/1723211086Citation-XLS-interior-1.jpg'),
        ],
    },
    {
        name: 'Falcon 50EX',
        category: 'Heavy Jet',
        capacity: '9 passengers',
        range: '3,200 nm',
        speed: '480 kts',
        size: 'large',
        src: u('Falcon+50Falcon+50EX/1723211761Falcon-50EX_(1).jpg'),
        interiorSrc: [
            u('Falcon+50Falcon+50EX/1723211744Falcon-50EX-night.jpg'),
            u('Falcon+50Falcon+50EX/1723211761Falcon-50EX_(1).jpg'),
            u('Falcon+50Falcon+50EX/1723211777Falcon-50EX-interior-cockpit.jpg'),
            u('Falcon+50Falcon+50EX/1723211787Falcon-50EX-interior.jpg'),
        ],
    },
    {
        name: 'Falcon 900EX',
        category: 'Heavy Jet',
        capacity: '12–14 passengers',
        range: '4,500 nm',
        speed: '482 kts',
        size: 'large',
        src: u('Falcon+900++Falcon+900B++Falcon+900EX/1723213385Falcon-900EX-preflight.jpg'),
        interiorSrc: [
            u('Falcon+900++Falcon+900B++Falcon+900EX/1723213385Falcon-900EX-preflight.jpg'),
            u('Falcon+900++Falcon+900B++Falcon+900EX/1723213404Falcon-900EX-flight.jpg'),
            u('Falcon+900++Falcon+900B++Falcon+900EX/1723213445Falcon-900EX-interior.jpg'),
            u('Falcon+900++Falcon+900B++Falcon+900EX/1723213461Falcon-900EX-amenity.jpg'),
        ],
    },
    {
        name: 'Global Express BD-700',
        category: 'Heavy Jet',
        capacity: '13–14 passengers',
        range: '6,250 nm',
        speed: '488 kts',
        size: 'large',
        src: u('Global+Express+BD-700-1A10/1723214579Global-Express-BD-700-1A10-runway.jpg'),
        interiorSrc: [
            u('Global+Express+BD-700-1A10/1723214579Global-Express-BD-700-1A10-runway.jpg'),
            u('Global+Express+BD-700-1A10/1723214610Global-Express-BD-700-1A10-landing_(1).jpg'),
            u('Global+Express+BD-700-1A10/1723214619Global-Express-BD-700-1A10-interior.jpg'),
        ],
    },
    {
        name: 'Gulfstream G500',
        category: 'Heavy Jet',
        capacity: '13 passengers',
        range: '5,200 nm',
        speed: '516 kts',
        size: 'large',
        src: u('Gulfstream+G500/1723212026Gulfstream-G500_(1).jpg'),
        interiorSrc: [
            u('Gulfstream+G500/1723212015Gulfstream-G500-side.jpg'),
            u('Gulfstream+G500/1723212026Gulfstream-G500_(1).jpg'),
            u('Gulfstream+G500/1723212037Gulfstream-G500-seating.jpg'),
            u('Gulfstream+G500/1723212071Gulfstream-G500-bed.jpg'),
        ],
    },
    {
        name: 'Gulfstream GIV-SP',
        category: 'Heavy Jet',
        capacity: '12–14 passengers',
        range: '4,220 nm',
        speed: '476 kts',
        size: 'large',
        src: u('Gulfstream+GIVGulfstream+GIV+SP/1723212881Gulfstream-GIV-SP-side.jpg'),
        interiorSrc: [
            u('Gulfstream+GIVGulfstream+GIV+SP/1723212870Gulfstream-GIV-SP-landed.jpg'),
            u('Gulfstream+GIVGulfstream+GIV+SP/1723212881Gulfstream-GIV-SP-side.jpg'),
            u('Gulfstream+GIVGulfstream+GIV+SP/1723212906Gulfstream-GIV-SP-seating.jpg'),
            u('Gulfstream+GIVGulfstream+GIV+SP/1723212919Gulfstream-GIV-SP-interior.jpg'),
        ],
    },
    {
        name: 'Hawker 4000',
        category: 'Midsize Jet',
        capacity: '8–9 passengers',
        range: '3,280 nm',
        speed: '447 kts',
        size: 'large',
        src: u('Hawker+4000/1723211386Hawker-4000-runway.jpg'),
        interiorSrc: [
            u('Hawker+4000/1723211386Hawker-4000-runway.jpg'),
            u('Hawker+4000/1723211417Hawker-4000-landing.jpg'),
            u('Hawker+4000/1723211428Hawker-4000-interior.jpg'),
            u('Hawker+4000/1723211441Hawker-4000-seating.jpg'),
        ],
    },
    {
        name: 'Hawker 400XP',
        category: 'Light Jet',
        capacity: '7–8 passengers',
        range: '1,800 nm',
        speed: '445 kts',
        size: 'normal',
        src: u('Hawker+400XP/1723210409Hawker-400XP-preflight.jpg'),
        interiorSrc: [
            u('Hawker+400XP/1723210409Hawker-400XP-preflight.jpg'),
            u('Hawker+400XP/1723210421Hawker-400XP-mid-flight.jpg'),
            u('Hawker+400XP/1723210443Hawker-400XP-interior.jpg'),
        ],
    },
    {
        name: 'Hawker 800XP',
        category: 'Midsize Jet',
        capacity: '8 passengers',
        range: '2,540 nm',
        speed: '442 kts',
        size: 'normal',
        src: u('Hawker+800Hawker+800XP/1723479787Hawker-800XP_(1).jpg'),
        interiorSrc: [
            u('Hawker+800Hawker+800XP/1723479772Hawker-800XP-landed.jpg'),
            u('Hawker+800Hawker+800XP/1723479787Hawker-800XP_(1).jpg'),
            u('Hawker+800Hawker+800XP/1723479800Hawker-800XP-seating.jpg'),
            u('Hawker+800Hawker+800XP/1723479813Hawker-800XP-interior.jpg'),
        ],
    },
    {
        name: 'King Air BE-350',
        category: 'Turboprop',
        capacity: '9–11 passengers',
        range: '1,806 nm',
        speed: '312 kts',
        size: 'normal',
        src: u('King+Air+BE-350/1723210134King-Air-BE-350-flight_(1).jpg'),
        interiorSrc: [
            u('King+Air+BE-350/1723210119King-Air-BE-350-interior-airport_(1).jpg'),
            u('King+Air+BE-350/1723210134King-Air-BE-350-flight_(1).jpg'),
            u('King+Air+BE-350/1723210175King-Air-BE-350-interior-full_(1).jpg'),
            u('King+Air+BE-350/1723210191King-Air-BE-350-interior_(1).jpg'),
        ],
    },
    {
        name: 'Learjet 60',
        category: 'Midsize Jet',
        capacity: '7–8 passengers',
        range: '2,450 nm',
        speed: '465 kts',
        size: 'normal',
        src: u('Learjet+60/1723211197Learjet-60-landed.jpg'),
        interiorSrc: [
            u('Learjet+60/1723211177Learjet-60-midflight.jpg'),
            u('Learjet+60/1723211197Learjet-60-landed.jpg'),
            u('Learjet+60/1723211207Learjet-60-interior.jpg'),
        ],
    },
    {
        name: 'Legacy 650',
        category: 'Heavy Jet',
        capacity: '13–14 passengers',
        range: '3,900 nm',
        speed: '447 kts',
        size: 'large',
        src: u('Legacy+600650/1723214358Legacy-650-flight_(1).jpg'),
        interiorSrc: [
            u('Legacy+600650/1723214358Legacy-650-flight_(1).jpg'),
            u('Legacy+600650/1723214381Legacy-650-interior.jpg'),
            u('Legacy+600650/1723214417Legacy-650-seats.jpg'),
        ],
    },
    {
        name: 'Pilatus PC-12',
        category: 'Turboprop',
        capacity: '8–9 passengers',
        range: '1,845 nm',
        speed: '290 kts',
        size: 'normal',
        src: u('Pilatus+PC-12/1723209632Pilatus-PC-12.jpg'),
        interiorSrc: [
            u('Pilatus+PC-12/1723209567Pilatus-PC-12-landed.jpg'),
            u('Pilatus+PC-12/1723209619Pilatus-PC-12-flight.jpg'),
            u('Pilatus+PC-12/1723209632Pilatus-PC-12.jpg'),
            u('Pilatus+PC-12/1723209643Pilatus-PC-12-interior.jpg'),
            u('Pilatus+PC-12/1723209655Pilatus-PC-12-cockpit.jpg'),
        ],
    },
];

/** Hero / carousel: one slide per aircraft */
export const heroJetsFromGallery = PRIVATE_JETS_GALLERY.map(({ name, src }) => ({ name, src }));
